import React, { useState, useEffect } from "react";
import { List, ListItem, Box } from '@mui/joy';
import { useTranslation } from 'react-i18next';
import { LegalEntityAvatar, Tag } from "../Snippet";
import { Icon } from "../../assets";
import { useDrawer } from "../Drawer";
import { useFormatter } from "src/mtska-frontend-app-component/utils";

const InfoHeaderContract = ({ view, item }) => {
    const { t } = useTranslation();
    const { activate } = useDrawer();
    const { formatDistance, formatDate, formatCurrencyVariable } = useFormatter();

    const [endAt, setEndAt] = useState();
    useEffect(() => {
        if (!item) return;
        if (item?.end_at) {
            const endAt = new Date(item.end_at)
            setEndAt(endAt)
        } else if (item.start_at && item.contractDuration) {
            const endAt = new Date(item.start_at);
            endAt.setMonth(endAt.getMonth() + parseInt(item.contractDuration));
            endAt.setDate(endAt.getDate() - 1);

            setEndAt(endAt);
        }
    }, [item])

    return (
        <Box className={"info-header info-header-" + view}>
            <Box className={"info-wrapper"}>
                <>
                    <Box className="info-summary-external">
                        {
                            item?.legalEntity != null && <LegalEntityAvatar name={item?.legalEntity?.name} url={item?.legalEntity?.logo?.url} withname={true} />
                        }
                    </Box>
                    <Box className="info-name">
                        <span class="primary">{item?.contractIdentifier}</span>
                        <span class="secondary">{formatCurrencyVariable(item?.totalLeaseFee, 'EUR')}</span>
                    </Box>
                    <List className="info-details">
                        <ListItem>
                            <span className="key">{t('renter')}</span>
                            <span className="value">{item?.renter ? <Box className="info-summary-external"><LegalEntityAvatar name={item?.renter?.name} url={item?.renter?.logo?.url} size="small" withname={true} style={{ height: '23px' }} /></Box> : (<Tag color={"warning"} title={t("No renter defined")}><Icon icon="faWarning" />{t('No renter defined')}</Tag>)}</span>
                        </ListItem>
                        <ListItem>
                            <span className="key">{t('contractMileage')}</span>
                            <span className="value">{item?.contractMileage ? formatDistance(item?.contractMileage) : (<Tag color={"warning"} title={t("No mileage defined")}><Icon icon="faWarning" />{t('No mileage defined')}</Tag>)}</span>
                        </ListItem>
                        <ListItem>
                            <span className="key">{t('contractDuration')}</span>
                            <span className="value">{item?.contractDuration ? item?.contractDuration + t('months') : (<Tag color={"warning"} title={t("No duration defined")}><Icon icon="faWarning" />{t('No duration defined')}</Tag>)}</span>
                        </ListItem>
                        <ListItem>
                            <span className="key">{t('start_at')}</span>
                            <span className="value">{item?.start_at ? formatDate(item?.start_at) : (<Tag color={"warning"} title={t("No start_at defined")}><Icon icon="faWarning" />{t('No start_at defined')}</Tag>)}</span>
                        </ListItem>
                        <ListItem>
                            <span className="key">{t('end_at')}</span>
                            <span className="value">{endAt ? formatDate(endAt) : (<Tag color={"warning"} title={t("No end_at defined")}><Icon icon="faWarning" />{t('No end_at defined')}</Tag>)}</span>
                        </ListItem>
                        <ListItem>
                            <span className="key">{t('vehicle status')}</span>
                            <Box className="value">
                                {
                                    item?.car?.status ? (<Tag color={"secondary"} size="small" label={t(item?.car?.status)} />) : (<Tag color={"danger"} title={t("Missing vehicle status")}><Icon icon="faWarning" />{t('Missing')}</Tag>)
                                }
                            </Box>
                        </ListItem>
                        <ListItem>
                            <span className="key">{t('has_reajusted')}</span>
                            <span className="value">{item?.parentContract ? <Icon icon="faCircleCheck" family='fas' style={{ color: 'rgb(73, 153, 73)', marginTop: '4px' }} /> : <Icon icon="faCircleXmark" family='fas' style={{ color: '#FF0000', marginTop: '4px' }} />}</span>
                        </ListItem>
                        <ListItem>
                            <span className="key">{t('is_reajusted')}</span>
                            <span className="value">{item?.childContract ? <Icon icon="faCircleCheck" family='fas' style={{ color: 'rgb(73, 153, 73)', marginTop: '4px' }} /> : <Icon icon="faCircleXmark" family='fas' style={{ color: '#FF0000', marginTop: '4px' }} />}</span>
                        </ListItem>
                    </List>
                </>
            </Box>

        </Box>
    )
}

export default InfoHeaderContract;